import { Row, Col, Image, Alert } from 'antd';
import DragonLogo from '../../images/g-dragon-logo.png'
import DragonOwnerDetails from './DragonOwnerDetails';
import DragonHiringWidget from './DragonHiringWidget';
import DragonFarmStatWidget from './DragonFarmStatWidget';
import TotalStakedAmount from './Dashboard/TotalStakedAmount';
import TotalRefBonus from './Dashboard/TotalRefBonus';
import ContractBalance from './Dashboard/ContractBalance';
import TotalDragons from './Dashboard/TotalDragons';
import { useWeb3React } from '@web3-react/core';
import DragonReferralWidget from './DragonReferralWidget'

export default function DashboardWidget() {

    const { account, chainId } = useWeb3React()
    return (

        <div>
            <Row className='mt-5'>
                <Col span={24}>

                    <div className='main-app-description-container'>
                        <div className='app-description-logo'>
                            <Image
                                height={75}
                                width={250}
                                preview={false}
                                src={DragonLogo}
                            />
                        </div>
                        <div className='app-description-text-container mt-3'>
                            <div className='app-description-text-title'>
                                G Dragon
                            </div>
                            <div className='app-description-text-tagline'>
                                A smart and sustainable way to grow your BNB on the BSC Chain
                            </div>
                        </div>

                    </div>

                    <div className='alert-container mt-4'>

                        {
                            account && chainId !== 56 ? (
                                <Alert
                                    message="Wrong Network"
                                    description="You are currently in wrong network please switch to BSC mainnet to continue"
                                    type="warning"
                                    showIcon
                                    closable
                                />
                            ) : (
                                <></>
                            )
                        }

                    </div>

                    <Row className='mt-5 contract-statistic-widgets'>
                        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
                            <TotalStakedAmount />
                        </Col>

                        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
                            <TotalRefBonus />
                        </Col>

                        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
                            <ContractBalance />
                        </Col>

                        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
                            <TotalDragons />
                        </Col>

                    </Row>

                    <DragonOwnerDetails
                        accountAddress={account}
                        suffix="BNB"
                        thousandSeparator={true}
                    />


                    <Row className='dragon-war-training-container'>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} className='mobile-top-margin px-2'>
                            <DragonHiringWidget />
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={12} xl={12} className='mobile-top-margin px-2'>
                            <DragonFarmStatWidget
                                accountAddress={account}
                            />
                        </Col>
                    </Row>
                    <Row className='mt-5 contract-statistic-widgets'>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mobile-top-margin px-2'>
                            <DragonReferralWidget />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}